import React, { Component, Fragment } from "react";
import { withRouter , Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import { FEDERAL, ESTADUAL, MUNICIPAL } from "../../providers/constEsferasAdministrativas";
import api from "../../services/api";
import './ConjuntoArquivosGrandesVolumes.css';
import { faFilePen, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
    return {
        user: state.usuarioStore.user,
        filters: state.filterStore,
    }
}

export const ConjuntoArquivoGrandesVolumesList =

withRouter(

// redux
connect(
    (mapStateToProps), 
    (mapDispatchToProps)
)(

    class extends Component {

        constructor(props){
            super(props);
            this.initialState = {
                criterioPesquisa: {
					orgaoCedente: '',
					esferaAdministrativa: '',
					conjuntoArquivoGV : '',
                    ativos: '',
				},
                conjuntosDeArquivosGV: [],
                orgaosCedentes: [],
                carregandoConjuntosDeArquivosGV: true,
                carregandoorgaosCedentes: true,
                resultadoPesquisa: {},
                pesquisaExecutada : false,
                exibeModalAtivar: false,
                exibeModalInativar: false,
                esferasAdministrativas: [ESTADUAL, FEDERAL, MUNICIPAL],
            };
            
            this.state = this.initialState;
            
            this.handleAtivoChange = this.handleAtivoChange.bind(this);
            this.handleOrgaoCedenteChange = this.handleOrgaoCedenteChange.bind(this);
			this.handleConjuntoDeArquivosGVChange = this.handleConjuntoDeArquivosGVChange.bind(this);
            this.handleEsferaAdministrativaChange = this.handleEsferaAdministrativaChange.bind(this);
            this.pesquisar = this.pesquisar.bind(this);
            this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
            this.limparPesquisa = this.limparPesquisa.bind(this);
        }

        render() {
            return (
                <main id="content" className="page-content p-3">
                    <Message />
                    <Loading />
                    <div style={{margin: "10px"}}>
                        <h1>Conjuntos de Arquivos de Grandes Volumes</h1>
                    </div>
                    <div className="div-form1">
                        {this.renderForm()}
                    </div>
                </main>
            );
        }

        componentDidMount(){            
            this.props.limpaMensagem();
            this.setState(
                {
                    carregandoorgaosCedentes: true,
                    carregandoConjuntosDeArquivosGV: true
                }
            );

            api.get('/api/orgao/fornecedores-arquivo-gv')
            .then(response => { 
                this.setState(
                    {
                        orgaosCedentes: response.data,
                        carregandoorgaosCedentes: false
                    }
                ) 
            })
            .catch(erro => {
                this.setState({carregandoorgaosCedentes : false});
                console.log("Não foi possível recuperar órgãos fornecedores" + erro)
                this.props.exibeMensagemErro("Erro durante o carregamento da página")
            });

            this.carregaConjuntoDeArquivos();

            if (!this.props.location.state?.resetSearch) {
                this.executarPesquisaAnterior();
            }
        }

        renderForm() {
            const { resultadoPesquisa, pesquisaExecutada, criterioPesquisa } = this.state;
            const { content } = resultadoPesquisa;

            const { orgaoCedente, esferaAdministrativa, conjuntoArquivoGV, ativos } = criterioPesquisa;

            return(
                <div className="container-fluid">
                    <div className="br-form">
                        <div className="row">
                            <div className="col-md">
                                <div className="field">
                                    <div className="input">
                                        <label htmlFor="orgaoCedente">Órgao Cedente:</label>
                                        { this.state.orgaosCedentes.length > 0 && 
                                            <SelectSearch
                                                id="orgaoCedente"
                                                name="orgaoCedente"
                                                options={this.state.orgaosCedentes.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
                                                includeAllOption={true}
                                                onChange={this.handleOrgaoCedenteChange}
                                                value={orgaoCedente}
                                            />
                                        }
                                        {this.state.carregandoorgaosCedentes === true && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
                                        {this.state.carregandoorgaosCedentes === false && this.state.orgaosCedentes.length === 0 && 'Não há órgãos cedentes de conjuntos de arquivos'}
                                    </div>
                                </div>
                            </div>
                                        
                            { this.props.user.isAdministrador === true &&
                                <div className="col-sd">
                                    <div className="field">
                                        <div className="input">
                                            <label>Esfera Administrativa:</label>
                                            <SelectSearch
                                                id="esferaAdministrativa"
                                                name="esferaAdministrativa"
                                                allOptionName="Todas"
                                                options={this.state.esferasAdministrativas.map(esfera => ({ value: esfera.codigo, label: esfera.nome }))}
                                                includeAllOption={true}
                                                onChange={this.handleEsferaAdministrativaChange}
                                                value={esferaAdministrativa}
                                            />
                                        </div>
                                    </div>
                                </div>	
                            }

                            <div className="col-md">
                                <div className="field">
                                    <div className="input">
                                        <label>Conjunto de Arquivos:</label>
                                        { this.state.carregandoConjuntosDeArquivosGV === false && this.state.conjuntosDeArquivosGV.length > 0 && 
                                            <SelectSearch
                                                id="conjuntoDeArquivosGV"
                                                allOptionName="Todas"
                                                name="conjuntoDeArquivosGV"
                                                options={this.state.conjuntosDeArquivosGV.map(conjunto => ({ value: conjunto.id, label: conjunto.titulo }))}
                                                includeAllOption={true}
                                                onChange={this.handleConjuntoDeArquivosGVChange}
                                                value={conjuntoArquivoGV}
                                            />
                                        }
                                        {this.state.carregandoConjuntosDeArquivosGV === true && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
                                        {this.state.carregandoConjuntosDeArquivosGV === false && this.state.conjuntosDeArquivosGV.length === 0 && 'Não foram encontrados conjuntos de arquivos com os critérios informados.'}
                                    </div>
                                </div>
                            </div>
                        </div>
                
                        <div className="row">
                            <div className="col-6">
                                <div className="field">
                                    <div className="input">
                                        <label htmlFor="ativos">Situação:</label>
                                        <SelectSearch
                                            id="ativos"
                                            name="ativos"
                                            options={[{ value: true, label: 'Ativo' }, { value: false, label: 'Inativo' }]}
                                            includeAllOption={true}
                                            onChange={this.handleAtivoChange}
                                            value={ativos}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="actions-button">
                            <div className="actions justify-content-start">
                                <button type="button" className="button is-primary" onClick={this.pesquisar}>Pesquisar</button>
                                <button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()}>Limpar</button>
                                <ButtonBack />
                            </div>
                        </div>

                        {(content && content.length > 0) &&	
                            <div className="br-table">						
                                <div className="table">
                                    <table>
                                        <thead>
                                            <tr>
                                            <th scope="col">Título</th>
                                            <th scope="col">Órgão Cedente</th>
                                            <th scope="col" >Esferas</th>
                                            <th scope="col" >Situação</th>                         
                                            <th className="text-center" scope="col">Ações</th>
                                            </tr>
                                        </thead>
                                        
                                        <tbody>
                                            { content.map((conjuntoArquivoGV, index) =>
                                                    <tr key={index} >
                                                        <td>{conjuntoArquivoGV.titulo}</td>
                                                        <td>{conjuntoArquivoGV.nomeOrgao}</td>
                                                        <td>{conjuntoArquivoGV.esferasAdministrativas.map(esfera => <Fragment key={esfera.id}>{esfera.nome}<br/></Fragment>)}</td>
                                                        <td>{conjuntoArquivoGV.ativo ? 'Ativo' : 'Inativo'}</td>
                                                        <td className="text-center">
                                                            <div className="actions">

                                                                <Link to={`/conjunto-arquivo-grandes-volumes/view/${conjuntoArquivoGV.id}`}>
                                                                    <button type="button" title="Visualizar o conjunto de arquivos de grandes volumes">
                                                                        <span className="sr-only">Visualizar</span>
                                                                        <FontAwesomeIcon icon={faMagnifyingGlass} style={{color: "#1351b4"}} />
                                                                    </button>
                                                                </Link>		

                                                                { conjuntoArquivoGV.permiteAlteracao &&
                                                                    <Link to={`/arquivo-grandes-volumes/edit-conjunto-gv/${conjuntoArquivoGV.id}`}>
                                                                            <button type="button" title="Criar solicitação para alterar o cadastro de arquivos de grandes volumes">
                                                                                <span className="sr-only">Solicitação de Alteração</span>
                                                                                <FontAwesomeIcon icon={faFilePen} style={{color: "#1351b4"}} />
                                                                            </button>
                                                                    </Link>	
                                                                }

                                                                { conjuntoArquivoGV.permiteAdesao &&
                                                                    <Link to={`/solicitacao-adesao-arquivo-gv/new?conjuntoArquivo=${conjuntoArquivoGV.id}`}>
                                                                            <button type="button" title="Solicitar adesão ao conjunto de arquivos de grandes volumes" onClick={() => this.props.saveState({idConjuntoArquivoGV: conjuntoArquivoGV.id}, '/solicitacao-adesao-arquivo-gv/new')}>
                                                                                <span className="sr-only">Adesões</span>
                                                                                <i className="fas fa-handshake"></i>
                                                                            </button>
                                                                    </Link>	
                                                                }

                                                                { this.props.user.isAdministrador === true &&
                                                                    <Link to={`/conjunto-arquivo-grandes-volumes/attachments/${conjuntoArquivoGV.id}`}>
                                                                        <button type="button" title="Editar anexos do conjunto de arquivos de arquivos de grandes volumes">
                                                                            <span className="sr-only">Anexos</span>
                                                                            <i className="fas fa-paperclip"></i>
                                                                        </button>
                                                                    </Link>		
                                                                }                                       	
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                        </tbody>
                                    </table>
                                    <Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
                                </div>
                            </div>
                        }

                        {(pesquisaExecutada && (!content || content.length === 0)) &&
                            <div>
                                Nenhum conjunto de arquivos de GV encontrado com os critérios informados.
                            </div>
                        }

                    </div>
                </div>

                
            );
        }

         handleAtivoChange(evento){
			const target = evento.target;
			const valor = target.value;

            this.setState(prevState => ({
                criterioPesquisa: {
                    ...prevState.criterioPesquisa,
                    ativos: valor,
                    conjuntoArquivoGV: '',
                }
            }), () => {
                this.carregaConjuntoDeArquivos();
            });
			
		}

        handleOrgaoCedenteChange(evento){
			const target = evento.target;
			const valor = target.value;
			
			this.setState(prevState => ({
                criterioPesquisa: {
                    ...prevState.criterioPesquisa,
                    orgaoCedente: valor,
                    conjuntoArquivoGV: '',
                }
            }), () => {
                this.carregaConjuntoDeArquivos();
            });
		}

		handleConjuntoDeArquivosGVChange(evento){
			const target = evento.target;
			const valor = target.value;
			
			this.setState(prevState => ({
                criterioPesquisa: {
                    ...prevState.criterioPesquisa,
                    conjuntoArquivoGV: valor,
                }
            }));
		}

        handleEsferaAdministrativaChange(evento){
            const target = evento.target;
			const valor = target.value;
			
			this.setState(prevState => ({
                criterioPesquisa: {
                    ...prevState.criterioPesquisa,
                    esferaAdministrativa: valor,
                    conjuntoArquivoGV: '',
                }
            }), () => {
                this.carregaConjuntoDeArquivos();
            });
        }


        carregaConjuntoDeArquivos(){
            this.setState({ carregandoConjuntosDeArquivosGV: true});	

            const { orgaoCedente, esferaAdministrativa, ativos } = this.state.criterioPesquisa;

            const params = new URLSearchParams();

           const paramMap = {
                idOrgao: orgaoCedente,
                codigoEsferaAdministrativa: esferaAdministrativa,
                ativos: ativos,
            };

            Object.entries(paramMap).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== '') {
                    params.append(key, value);
                }
            });

            const queryString = params.toString() ? `?${params.toString()}` : '';
		
            api.get(`/api/conjunto-arquivo-gv/orgao/esfera${queryString}`)
                .then(response => { 
                    this.setState({
                        conjuntosDeArquivosGV: response.data,
                        carregandoConjuntosDeArquivosGV: false
                    });
                })
                .catch(erro => {
                    console.log("Não foi possível recuperar os conjuntos de arquivos: " + erro);
                    this.setState({
                        conjuntosDeArquivosGV: [],
                        carregandoConjuntosDeArquivosGV: false
                    });
                });
            
        }

        executarPesquisaAnterior() {
            const lastState = this.props.filters[this.props.location.pathname];
            
            this.setState({
                ...this.initialState,
                ...lastState,
                pesquisaExecutada: false,
                resultadoPesquisa: {}
            }, () => {
                if (lastState) {
                    const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
                    this.executaPesquisaPaginada(lastPage);
                }
            });
        }

        pesquisar (e){
            this.props.limpaMensagem();
            this.executaPesquisaPaginada(0);
            if (this.props.location.state?.resetSearch) {
                this.props.history.replace(this.props.location.pathname, {
                    ...this.props.location.state,
                    resetSearch: false,
                  });
            }
        }

        executaPesquisaPaginada(pagina){
            const {orgaoCedente, esferaAdministrativa, conjuntoArquivoGV, ativos } = this.state.criterioPesquisa;
            const criterioPesquisa = {orgaoCedente, esferaAdministrativa, conjuntoArquivoGV, ativos, pagina};
            const url = '/api/conjunto-arquivo-gv/paginado';

            const options = {
                method: 'post',
                url,
                data: criterioPesquisa
            }

            this.props.mostraAguardando()
            api(options)
                .then(response => { 
                    this.setState({
                        resultadoPesquisa: response.data,
                        pesquisaExecutada : true,
                    }, () => {
                        this.props.saveState(this.state, this.props.location.pathname);
                    }) 
                })
                .catch(erro => {
                    console.log("Não foi possível recuperar os conjuntos de arquivos de GV: " + erro);
                    this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
                })
                .then( () => {
                    this.props.escondeAguardando();
                });
        }

        limparPesquisa(){
            this.props.limpaMensagem();
            this.setState({
                criterioPesquisa: {
                    orgaoCedente: '',
                    esferaAdministrativa: '',
                    conjuntoArquivoGV: '',
                    ativos: '',
                },
                resultadoPesquisa: {},
                pesquisaExecutada: false,
            }, () => {
                this.carregaConjuntoDeArquivos();
                this.props.deleteState(this.state, this.props.location.pathname);
            });
        }
    }

) // redux
); // router